// Updated: src/components/ThemeToggle.js

import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { FaSun, FaMoon } from 'react-icons/fa';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Listen for chat window opening/closing
  useEffect(() => {
    const checkChatStatus = () => {
      // Check if LiveChat popup is visible
      const chatPopup = document.querySelector('[class*="animate-slideUp"]');
      setIsChatOpen(!!chatPopup);
    };

    // Check every 100ms
    const interval = setInterval(checkChatStatus, 100);
    
    return () => clearInterval(interval);
  }, []);

  // Hide when chat is open
  if (isChatOpen) {
    return null;
  }

  return (
    <>
      <button
        onClick={toggleTheme}
        className="fixed right-6 bottom-24 z-50 bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-500 dark:from-blue-600 dark:via-purple-600 dark:to-pink-600 p-4 rounded-full shadow-2xl hover:scale-110 hover:rotate-12 transition-all duration-300 group animate-float"
        aria-label="Toggle theme"
      >
        {/* Glow effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 to-orange-500 dark:from-blue-600 dark:to-purple-600 rounded-full opacity-50 blur-xl animate-pulse"></div>
        
        <div className="relative w-8 h-8 flex items-center justify-center">
          {theme === 'light' ? (
            <FaMoon className="text-white text-2xl animate-bounce-slow" />
          ) : (
            <FaSun className="text-yellow-300 text-2xl animate-spin-slow" />
          )}
        </div>
        
        {/* ✅ FIXED TOOLTIP - Only shows on hover */}
        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-gradient-to-r from-gray-900 to-gray-800 dark:from-gray-800 dark:to-gray-700 text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 shadow-xl border border-gray-700 dark:border-gray-600">
          {theme === 'light' ? '🌙 Switch to Dark Mode' : '☀️ Switch to Light Mode'}
          <span className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-45 w-2 h-2 bg-gray-900 dark:bg-gray-800 border-r border-b border-gray-700 dark:border-gray-600"></span>
        </span>

        {/* Ripple effect on click */}
        <span className="absolute inset-0 rounded-full bg-white dark:bg-blue-400 opacity-0 group-active:opacity-30 group-active:scale-150 transition-all duration-500"></span>
      </button>

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }

        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
      `}</style>
    </>
  );
};

export default ThemeToggle;